import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
export var GET_APP_NAME = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tquery app($id: ID!) {\n\t\tapp(id: $id) {\n\t\t\tname\n\t\t}\n\t}\n"])));